var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4492 8.75H30.1758C28.1576 8.75 26.4323 9.46615 25 10.8984C23.6328 12.3307 22.9492 14.056 22.9492 16.0742V21.25H18.75V27.5H22.9492V42.0508H29.1992V27.5H35.4492V21.25H29.1992V17.0508C29.1992 16.5299 29.3945 16.0742 29.7852 15.6836C30.1758 15.2279 30.6641 15 31.25 15H35.4492V8.75ZM0 0.449219H41.6992V42.0508H0V0.449219Z",
    fill: "#0084E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.03679a7bda1165744d7800132945eab3.svg";
export { ForwardRef as ReactComponent };